import { ToastrManager } from 'ng6-toastr-notifications';
import { Component, Injector} from '@angular/core';
import { AuthService } from 'src/app/shared/services/auth.service';
import { BaseListComponent } from 'src/app/shared/components/base-list-component/base-list-component';
import { Partner } from './partner.model';
import { PartnersService } from './partiners.service';

@Component({
  selector: 'app-partiners',
  templateUrl: './partiners.component.html',
  styleUrls: ['./partiners.component.css']
})
export class PartinersComponent extends BaseListComponent<Partner> {
  
  constructor(
    public partinersServ:PartnersService,
    public injector:Injector,
    public auth:AuthService,
    public toastr:ToastrManager,
  ){
    super(partinersServ, injector, 'partner', {editUrl:'/admin/partners/edit', createUrl:'/admin/partners/new',detailUrl:'/admin/partners/detail'});
  }

  // unimplemented method
  protected initChildProprieties(): void {}
  
  
  // unimplemented method
  protected initChildMethods(): void {}

  tableProprieties(): string[] {
    return [
      'Parceiro',
      'Provincia',
      'Endereço',
      'Telefone',
      'Data de Registo',
    ];
  }
}
